export default __webpack_public_path__ + "static/media/login-tablet-background.e7060289.svg";